import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes } from '@/utils'

import tag from '@/components/tag'

export default function(h) {
  if (this.canGetSendingsModeration) {
    if (this.count > 0) {
      return h(
        tag,
        {
          props: {
            label: this.count,
            color: Colors.primary,
            mode: buttonModes.filled
          }
        }
      )
    }
  }
}
